import PickerTag from '@sdk/components/ui/PickerTag';
import { TAG_ICONS_DICT } from '@sdk/components/forms/personaPickers/PersonaPicker/PersonaPickerTags/personaPickerTags.consts';

import { RecipientsSkeleton } from './components/RecipientsSkeleton';
import { useRecipients } from './announcementRecipients.hooks';
import { ScrollContainer } from './announcementRecipients.styles';

type Props = {
  ids: ID[];
  total: number;
};

const RECIPIENTS_PREDICT_COUNTER = 9;

export const AnnouncementRecipients = ({ total, ids }: Props) => {
  const recipients = useRecipients(ids);
  const showSkeleton = total !== 0 && ids.length === 0;

  return (
    <ScrollContainer>
      {showSkeleton ? (
        <RecipientsSkeleton counter={RECIPIENTS_PREDICT_COUNTER} />
      ) : (
        recipients.map((r) => (
          <PickerTag
            key={r.id}
            label={r.title}
            suffixLabel={r.subtitle}
            icon={TAG_ICONS_DICT[r.type]}
          />
        ))
      )}
    </ScrollContainer>
  );
};
